import React, { useState } from 'react';
import {
    Box, TextField, Popover, IconButton
} from '@mui/material';
import { LocalizationProvider, DateCalendar, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs from 'dayjs';

const DatePickerCalendar = ({
    value,
    onChange,
    label = "תאריך",
    fullWidth = true,
    margin = "normal",
    disabled = false,
    placeholder = "בחר תאריך",
    multiple = false,
    required = false,
    error = false,
    helperText = '',
    disablePortal = false,
    popoverZIndex = 2000
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopover = Boolean(anchorEl);

    const handleDateChange = (date) => {
        if (multiple) {
            const dateExists = value.some(d => dayjs(d).isSame(date, 'day'));
            let newDates;
            if (dateExists) {
                newDates = value.filter(d => !dayjs(d).isSame(date, 'day'));
            } else {
                newDates = [...value, date.toISOString()];
            }
            onChange(newDates);
        } else {
            onChange(date.toISOString());
            setAnchorEl(null);
        }
    };

    const displayValue = () => {
        if (multiple) {
            if (!value || value.length === 0) return '';
            return value.map(d => dayjs(d).format("DD/MM/YYYY")).join(', ');
        }
        return value ? dayjs(value).format("DD/MM/YYYY") : '';
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <Box
                onClick={(e) => !disabled && setAnchorEl(e.currentTarget)}
                sx={{ display: 'flex', alignItems: 'center' }}
            >
                <TextField
                    label={label}
                    value={displayValue()}
                    fullWidth={fullWidth}
                    margin={margin}
                    disabled={disabled}
                    placeholder={placeholder}
                    required={required}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <IconButton disabled={disabled}>
                                <CalendarTodayIcon />
                            </IconButton>
                        ),
                        sx: {
                            direction: 'rtl',
                            cursor: disabled ? 'default' : 'pointer'
                        },
                    }}
                />
            </Box>

            <Popover
                open={openPopover}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disablePortal={disablePortal}
                PaperProps={{
                    sx: {
                        mt: 1,
                        width: '350px !important',
                        maxWidth: '350px !important',
                        height: '340px !important',
                        borderRadius: '16px',
                        maxHeight: '400px',
                        padding: '0px !important',
                        zIndex: popoverZIndex,
                    }
                }}
            >
                <Box sx={{ p: 1, width: '100%', height: '100%' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
                        <DateCalendar
                            value={multiple ? null : (value ? dayjs(value) : null)}
                            onChange={handleDateChange}
                            slots={{
                                day: (props) => {
                                    const isSelected = multiple
                                        ? value?.some(d => dayjs(d).isSame(props.day, 'day'))
                                        : dayjs(value).isSame(props.day, 'day');

                                    return (
                                        <PickersDay
                                            {...props}
                                            disableMargin
                                            sx={{
                                                '&:hover': { bgcolor: '#e7efe3' },
                                                ...(isSelected && {
                                                    bgcolor: '#1B5C1C !important',
                                                    color: '#fff !important',
                                                    '&:hover': { bgcolor: '#1B5C1C !important' },
                                                }),
                                                ...(dayjs().isSame(props.day, 'day') && !isSelected && {
                                                    border: '1px solid #1B5C1C',
                                                    bgcolor: 'transparent',
                                                }),
                                            }}
                                        />
                                    );
                                }
                            }}
                            sx={{
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Popover>
        </Box>
    );
};

export default DatePickerCalendar; 